module.exports = __webpack_public_path__ + "static/media/CATT09.795aac52.jpg";